import { Box } from '@chakra-ui/react';
import { useTurnTo } from '../../../contexts/useTurnTo';
import { QuestionItem } from './QuestionItem';
import type { AnswerTypes } from '../../../bff-api/turn-to/model';

export const QuestionsList = () => {
    const { questions, isLoading } = useTurnTo();
    if (!questions || !questions.length || isLoading) {
        return null;
    }

    return (
        <Box paddingY={{ base: 4, lg: 8 }} paddingX={{ base: 0, 'lg-sm': 4 }} background="white">
            {questions?.map(({ id, text, dateCreated, user, upVotes, answers }) => (
                <QuestionItem
                    key={id}
                    dateCreated={dateCreated}
                    text={text}
                    user={user}
                    upVotes={upVotes}
                    bestAnswer={answers.find((answer) => answer.bestAnswer === true) as AnswerTypes}
                    id={id}
                    answers={answers}
                />
            ))}
        </Box>
    );
};
